export const API_LINK_MANAGEMENT_URL = '/enterprises-admin/';

export const ALL_OPTIONS_ASSETS = {
  id: 'All',
  title: 'All',
  photoUrl: '',
  companyId: '',
  createdAt: '',
  updatedAt: '',
  deletedAt: null,
  isTalent: false,
  status: 0,
  category: 0,
  lastScannedAt: null,
};
